import Vue from 'vue'
import VueI18n from 'vue-i18n'
import scLocale from './sc'
import tcLocale from './tc'
import enLocale from './en'
import ruLocale from './ru'
import jpLocale from './jp'
import esLocale from './es'
import thLocale from './th'
import hiLocale from './hi'
import ptLocale from './pt'
import trLocale from './tr'
import krLocale from './kr'
import itLocale from './it'
import viLocale from './vi'
import frLocale from './fr'
import deLocale from './de'
import uzLocale from './uz'

Vue.use(VueI18n)

const messages = {
  sc: {
    ...scLocale
  },
  tc: {
    ...tcLocale
  },
  en: {
    ...enLocale
  },
  ru: {
    ...ruLocale
  },
  jp: {
    ...jpLocale
  },
  es: {
    ...esLocale
  },
  th: {
    ...thLocale
  },
  hi: {
    ...hiLocale
  },
  pt: {
    ...ptLocale
  },
  tr: {
    ...trLocale
  },
  kr: {
    ...krLocale
  },
  it: {
    ...itLocale
  },
  vi: {
    ...viLocale
  },
  fr: {
    ...frLocale
  },
  de: {
    ...deLocale
  },
  uz: {
    ...uzLocale
  }
}

const getUrlParam = function (paraName) {
  let url = document.location.search
  let arrObj = url.split('?')
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split('&')
    let arr

    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')

      if (arr !== null && arr[0] === paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getUrlParam('country') || 'en',

  // set locale messages
  messages
})

export default i18n
